import React, { useState, useEffect } from "react";
import ButtonAppBar from "./navbar/navbar";
import TemporaryDrawer from "./sidebar/sidebar";
import FloatingActionButton from "./buttons/fbutton";
import FloatingActionButtonTop from "./buttons/fbuttonTop";

export default function LayoutAppBar() {
  const [drawerOpen, setDrawerOpen] = useState(false);
const [showTopButton, setShowTopButton] = useState(false);

  const toggleDrawer = (open) => () => {
    setDrawerOpen(open);
  };


  useEffect(() => {
    const checkScrollable = () => {
      setShowTopButton(false);
      setShowTopButton(document.body.scrollHeight > window.innerHeight  + 2000);
    };
    checkScrollable();
    window.addEventListener("resize", checkScrollable);
    window.addEventListener("scroll", checkScrollable);
    return () => {
      window.removeEventListener("resize", checkScrollable);
      window.removeEventListener("scroll", checkScrollable);
    };
  }, []);

  return (
    <>
      <ButtonAppBar toggleDrawer={toggleDrawer} />
       {showTopButton && <FloatingActionButtonTop />}
      <FloatingActionButton toggleDrawer={toggleDrawer} />
      <TemporaryDrawer open={drawerOpen} toggleDrawer={toggleDrawer} />
    </>
  );
}
